import { UrlConstants } from "../url.constants";
export class ApiUserSettingsConstants {
    static URL = UrlConstants.API_V2 + "UserSettings";
}
